<template>
  <div class="duration">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Job Duration</h4>
        <div class="text-left">
          <label for="opt1" class="radio text-left">
            <input type="radio" name="rdo" id="opt1" class="hidden" value="1" v-model="duration" />
            <span class="label"></span>1 month
          </label>
          <br />
          <label for="opt2" class="radio text-left">
            <input type="radio" name="rdo" id="opt2" class="hidden" value="2" v-model="duration" />
            <span class="label"></span>2 months
          </label>
          <br />
          <label for="opt3" class="radio text-left">
            <input type="radio" name="rdo" id="opt3" class="hidden" value="3" v-model="duration" />
            <span class="label"></span>3 months
          </label>
          <br />

          <label for="opt4" class="radio text-left">
            <input type="radio" name="rdo" id="opt4" class="hidden" value="4" v-model="duration" />
            <span class="label"></span>6 months
          </label>
          <br />

          <label for="opt5" class="radio text-left">
            <input type="radio" name="rdo" id="opt5" class="hidden" value="5" v-model="duration" />
            <span class="label"></span>1 year or more
          </label>
          <br />
        </div>
        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "job-duration",
  data() {
    return {
      duration: this.$store.state.fcjob.fcjobData.duration
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { duration } = this;
      this.$store.commit("fcjob/updateFcJob", {
        duration
      });
      this.$router.push("job-work-hour");
    },
    skip() {
      this.$router.push("job-work-hour");
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
